import React, { useState } from 'react';
import { TabViewField } from 'src/components/widgets';
import { localizationService, UtilService } from 'src/services';
import { CccHazard } from '@rcp/types';
import { CccHazardServiceTabModal } from './hazard-service-tab-modal';

interface OwnProps {
	currentCccHazard: CccHazard;
}

type Props = OwnProps;

export const CccHazardServiceTab: React.SFC<Props> = props => {
	const [isToggle, setIsToggle] = useState(false);

	const onEditClicked = (e: any) => {
		e.preventDefault();
		setIsToggle(true);
	};

	const toggle = () => {
		setIsToggle(!isToggle);
	};

	return (
		<>
			<div className="d-flex flex-row">
				<div className="form-row">
					<TabViewField
						title={localizationService.getLocalizedString('cccHazard.accountNumber')}
						value={UtilService.formatValue(props.currentCccHazard.accountNumber)}
					/>
					<TabViewField
						title={localizationService.getLocalizedString('cccHazard.serviceNumber')}
						value={UtilService.formatValue(props.currentCccHazard.serviceNumber)}
					/>
					<TabViewField
						title={localizationService.getLocalizedString('cccHazard.category')}
						value={UtilService.formatValue(props.currentCccHazard.category)}
					/>

					<TabViewField
						title={localizationService.getLocalizedString('cccHazard.meterNumber')}
						value={UtilService.formatValue(props.currentCccHazard.meterNumber)}
					/>
					<TabViewField
						title={localizationService.getLocalizedString('cccHazard.lineSize')}
						value={UtilService.formatValue(props.currentCccHazard.lineSize)}
					/>
					<TabViewField
						title={localizationService.getLocalizedString('cccHazard.meterLocation')}
						value={UtilService.formatValue(props.currentCccHazard.meterLocation)}
					/>

					<TabViewField
						title={localizationService.getLocalizedString('cccHazard.serviceStatus')}
						value={UtilService.formatValue(props.currentCccHazard.serviceStatus)}
					/>
					<TabViewField
						title={localizationService.getLocalizedString('cccHazard.protection')}
						value={UtilService.formatValue(props.currentCccHazard.protection)}
					/>
					<TabViewField
						title={localizationService.getLocalizedString('cccHazard.serviceType')}
						value={UtilService.formatValue(props.currentCccHazard.serviceType)}
					/>
					<TabViewField
						title={localizationService.getLocalizedString('cccHazard.shutOffDate')}
						value={UtilService.formatDateTime(props.currentCccHazard.shutOffDate)}
					/>
				</div>
				<div className="ml-3">
					<a href="#/" onClick={onEditClicked}>
						{localizationService.getLocalizedString('screen.buttons.edit')}
					</a>
				</div>
			</div>
			{isToggle && (
				<CccHazardServiceTabModal currentHazard={props.currentCccHazard} isToggle={isToggle} toggle={toggle} />
			)}
		</>
	);
};
